module.exports = __webpack_public_path__ + "static/img/drilling1.cce240bd.png";